export async function getTranslations(locale: string) {
    // @ts-ignore
    const translations = await import("../locales/*.json");
    const [language] = locale.split("_");
    return await (translations[language] || translations["en"])();
}